/* eslint-disable */
// Motor del globo "Mi mundo" (vanilla JS). React solo monta el contenedor; este módulo
// pinta el DOM interno, el canvas WebGL/2D y maneja toda la interacción por frame.
import * as d3 from 'd3-geo';
import * as topojson from 'topojson-client';

export const MARKUP = `<div id="app" data-estilo="realista">
  <nav id="barra" aria-label="Navegación de Mi mundo"><div id="barraNav"></div></nav>
  <aside id="panel"><div id="panelIn"></div></aside>
  <div id="stage">
    <canvas id="cvStars"></canvas>
    <canvas id="cvGL"></canvas>
    <canvas id="cvIllu"></canvas>
    <canvas id="cvFx"></canvas>
    <div id="pins"></div>
    <div id="polas"></div>
    <div id="modos" role="tablist">
      <button data-m="viajes" class="on"><i class="fa-solid fa-location-dot"></i> Mis viajes</button>
      <button data-m="viajeros"><i class="fa-solid fa-heart"></i> Mis viajeros</button>
    </div>
    <div id="hint"><i class="fa-regular fa-hand-pointer"></i> <span>Arrastra para girar · toca un viaje</span></div>
  </div>
</div>
<div id="lb" aria-hidden="true">
  <div class="lb-top"><div class="lb-title"></div><a class="cta-wa sm" target="_blank" rel="noopener"><i class="fa-brands fa-whatsapp"></i> <span></span></a><button class="lb-x" aria-label="Cerrar"><i class="fa-solid fa-xmark"></i></button></div>
  <div class="lb-main"><button class="lb-nav prev" aria-label="Anterior"><i class="fa-solid fa-chevron-left"></i></button><img class="lb-img" alt=""><button class="lb-nav next" aria-label="Siguiente"><i class="fa-solid fa-chevron-right"></i></button></div>
  <div class="lb-cap"><span class="lb-txt"></span><span class="lb-n"></span></div>
  <div class="lb-thumbs"></div>
</div>`;

/**
 * @param {HTMLElement} root  contenedor (recibe la clase .mm)
 * @param {import('../../services/mundo').DatosMundo} D  datos del globo (src/services/mundo.js)
 * @param {{estilo?: 'realista'|'ilustrado', base?: string, onCambio?: Function}} opciones
 */
export function iniciarMundo(root, D, opciones = {}) {
  let dead = false, raf = 0;
  const offs = [];
  const on = (t, ev, fn, o) => { t.addEventListener(ev, fn, o); offs.push(() => t.removeEventListener(ev, fn, o)); };
  root.classList.add('mm');
  root.innerHTML = MARKUP;

  const D2R = Math.PI / 180;
  const qs = new URLSearchParams('');
  const REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s) => root.querySelector(s);
  // Alto del navbar fijo del sitio (variable CSS --nav-h): los scrolls dejan el contenido justo debajo.
  const navH = () => parseFloat(getComputedStyle(root).getPropertyValue('--nav-h')) || 0;
  const app = $('#app'), stage = $('#stage'), cvStars = $('#cvStars'), cvGL = $('#cvGL'), cvIllu = $('#cvIllu'), cvFx = $('#cvFx');
  const pinsEl = $('#pins'), polasEl = $('#polas'), panel = $('#panel'), panelIn = $('#panelIn'), modos = $('#modos'), hint = $('#hint'), lb = $('#lb');
  const barra = $('#barra'), barraNav = $('#barraNav');

  // anio: año elegido en el selector (null = todos); filtra viajes, paradas, fotos y lightbox en todos los niveles
  const S = { estilo: opciones.estilo === 'ilustrado' ? 'ilustrado' : 'realista', modo: 'viajes', nivel: 'mundo', viaje: null, dest: null, lugar: null, anio: null, hover: null, spawn: null };
  let paradas = []; // paradas visibles del viaje abierto, en orden de ruta: solo las que tienen fotos del año elegido
  const V = { lon: -38, lat: 24, z: 1, R: 300, cx: 0, cy: 0 };
  let L = {}, tween = null, drag = null, vel = { lon: 0, lat: 0 }, lastInteract = 0, dirty = true, polas = [];

  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const fix = (s) => (s || '').replace('Reljo', 'Reloj');
  const fotosDe = D.fotosDe;
  const destIds = Object.keys(D.destinos);
  const tripOf = (id) => D.viajes.find((v) => v.paradas.indexOf(id) >= 0);
  const cover = (id, anio) => D.portadaDe(id, anio).micro;
  const enAnio = (v) => !S.anio || v.anios.indexOf(S.anio) >= 0;
  const plural = (n, uno, varios) => n === 1 ? uno : varios;
  // Dónde se gira el globo con el dedo o el mouse: en la vista general siempre; en un viaje solo en escritorio (en el
  // celular ahí se navega con la lista); en destinos y lugares nunca (sus polaroids están fijas en la pantalla y
  // parecerían despegarse). Sin giro, cualquier deslizamiento sobre el globo mueve la página.
  const giroPermitido = () => S.nivel === 'mundo' || (S.nivel === 'viaje' && !L.movil);
  const actualizarGiro = () => stage.classList.toggle('sin-giro', !giroPermitido());
  const flag = (p) => D.bandera(p);
  const wa = (t) => 'https://wa.me/' + D.contacto.wa + '?text=' + encodeURIComponent(t);
  const resena = (id) => D.resenas.find((r) => r.id === id);
  // la foto de una reseña se recorta en su punto de interés (CSS object-position, p. ej. '80% 50%'): pines, polaroids y avatares
  const encuadre = (pos) => (pos ? ' style="object-position:' + esc(pos) + '"' : '');
  // Quiénes viajaron a un lugar ("2 familias", "1 familia" o "1 viajera"): pie del pin de viajeros y detalle de la barra
  const quienesViajaron = (l) => {
    const rs = l.resenas.map(resena), n = rs.length;
    return n > 1 ? n + ' familias' : (rs[0].nombre.indexOf('Familia') === 0 ? '1 familia' : '1 viajera');
  };
  const lista = (a) => a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' y ' + a[a.length - 1];
  const hash = (s) => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0) % 2147483646 + 1; };

  /* ---------- proyección (idéntica a d3.geoOrthographic().rotate([-lon0,-lat0])) ---------- */
  function project(lon, lat, h) {
    const l = (lon - V.lon) * D2R, p = lat * D2R, p0 = -V.lat * D2R;
    const cp = Math.cos(p), x = Math.cos(l) * cp, y = Math.sin(l) * cp, z = Math.sin(p);
    const x2 = x * Math.cos(p0) - z * Math.sin(p0), z2 = z * Math.cos(p0) + x * Math.sin(p0);
    const k = V.R * (h || 1);
    return { x: V.cx + k * y, y: V.cy - k * z2, v: x2 };
  }

  /* ---------- layout ---------- */
  function layout() {
    const W = root.clientWidth || window.innerWidth, movil = W < 900;
    root.classList.toggle('movil', movil);
    // en el celular "Mis viajes / Mis viajeros" va en la barra fija de arriba de la lista; en escritorio va sobre el globo
    if (movil && modos.parentNode !== barra) barra.insertBefore(modos, barraNav);
    else if (!movil && modos.parentNode !== stage) stage.appendChild(modos);
    let view, sw, sh;
    if (!movil) {
      const pw = Math.round(clamp(W * 0.31, 340, 450));
      app.style.setProperty('--pw', pw + 'px');
      // El escenario va sticky y mide lo que dicta el CSS (alto de la ventana menos el navbar);
      // el panel crece con su contenido y se recorre con el scroll de la página.
      stage.style.height = '';
      sw = W; sh = Math.max(stage.clientHeight || 720, 460);
      view = { x: pw, y: 0, w: W - pw, h: sh };
    } else {
      sw = W; sh = Math.round(clamp(W * 1.08, 380, 560)); stage.style.height = sh + 'px';
      view = { x: 0, y: 0, w: W, h: sh };
    }
    L = { W, H: sh, movil, sw, sh, view, R0: Math.min(view.w, view.h) * (movil ? 0.4 : 0.385), dpr: Math.min(2, window.devicePixelRatio || 1) };
    V.cx = view.x + view.w / 2; V.cy = view.y + view.h / 2 + (movil ? 16 : 0);
    V.R = L.R0 * V.z;
    [cvStars, cvGL, cvIllu, cvFx].forEach((c) => { c.width = Math.round(sw * L.dpr); c.height = Math.round(sh * L.dpr); c.style.width = sw + 'px'; c.style.height = sh + 'px'; });
    hint.style.left = (view.x + view.w / 2) + 'px';
    hint.style.bottom = movil ? '14px' : '26px';
    // en el teléfono el deslizamiento vertical recorre la página: el giro es a los lados
    hint.querySelector('span').textContent = movil ? 'Desliza a los lados para girar · toca un viaje' : 'Arrastra para girar · toca un viaje';
    // caja del aviso en el escenario: las etiquetas del celular no la pisan mientras se ve
    const hx = view.x + view.w / 2, hy = sh - (movil ? 14 : 26);
    L.aviso = { x0: hx - hint.offsetWidth / 2, x1: hx + hint.offsetWidth / 2, y0: hy - hint.offsetHeight, y1: hy };
    drawStars(); dirty = true;
    medirEtiquetas();
    if (polas.length) respawnPolas();
    actualizarGiro();
    postHeight();
  }
  function postHeight() {
    if (opciones.onCambio) opciones.onCambio({ modo: S.modo, nivel: S.nivel });
  }

  /* ---------- fondo estrellado (realista) ---------- */
  function drawStars() {
    if (!L.sw) return;
    const x = cvStars.getContext('2d'); x.setTransform(L.dpr, 0, 0, L.dpr, 0, 0); x.clearRect(0, 0, L.sw, L.sh);
    if (S.estilo !== 'realista') return;
    const g1 = x.createRadialGradient(L.sw * 0.72, L.sh * 0.3, 0, L.sw * 0.72, L.sh * 0.3, L.sw * 0.6);
    g1.addColorStop(0, 'rgba(46,82,160,0.20)'); g1.addColorStop(1, 'rgba(46,82,160,0)');
    x.fillStyle = g1; x.fillRect(0, 0, L.sw, L.sh);
    const g2 = x.createRadialGradient(L.sw * 0.25, L.sh * 0.85, 0, L.sw * 0.25, L.sh * 0.85, L.sw * 0.45);
    g2.addColorStop(0, 'rgba(120,70,160,0.10)'); g2.addColorStop(1, 'rgba(120,70,160,0)');
    x.fillStyle = g2; x.fillRect(0, 0, L.sw, L.sh);
    let s = 9; const rnd = () => (s = (s * 16807) % 2147483647) / 2147483647;
    const n = Math.round(L.sw * L.sh / 2300);
    for (let i = 0; i < n; i++) {
      const px = rnd() * L.sw, py = rnd() * L.sh, r = Math.pow(rnd(), 3) * 1.35 + 0.3, a = 0.22 + rnd() * 0.7;
      x.fillStyle = rnd() < 0.14 ? 'rgba(255,226,190,' + a + ')' : 'rgba(228,238,255,' + a + ')';
      x.beginPath(); x.arc(px, py, r, 0, 6.3); x.fill();
    }
  }

  /* ---------- globo realista (WebGL, textura Blue Marble) ---------- */
  const GLG = (function () {
    // preserveDrawingBuffer: false → el teléfono no copia el globo en cada cuadro (se redibuja completo cuando cambia)
    const gl = cvGL.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, preserveDrawingBuffer: false });
    if (!gl) return null;
    // Mipmaps (con filtrado anisotrópico si el equipo lo tiene): la foto se reduce bien y no "parpadea" al girar.
    // La textura es la misma; el sesgo negativo conserva su nitidez (sin anisotrópico se afila un poco más).
    const der = gl.getExtension('OES_standard_derivatives');
    const aniso = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
    // se consulta al inicio: getParameter es síncrono y, después de subir la textura, obligaría a esperar a la GPU
    const maxAniso = aniso ? Math.min(8, gl.getParameter(aniso.MAX_TEXTURE_MAX_ANISOTROPY_EXT)) : 0;
    const vs = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';
    const fs = [
      der ? '#extension GL_OES_standard_derivatives : enable' : '',
      'precision highp float;',
      'uniform sampler2D uTex;uniform vec2 uC;uniform float uR;uniform float uCp;uniform float uSp;uniform float uLon;uniform vec3 uAt;uniform float uHas;uniform float uMip;',
      'const float PI=3.14159265359;',
      'void main(){',
      ' vec2 p=(gl_FragCoord.xy-uC)/uR; float r=length(p); float d=r-1.0;',
      // lejos del globo solo hay atmósfera; el margen de 3 px deja enteros los grupos de 2x2 píxeles de la orilla
      // (las derivadas que eligen el mipmap se calculan por grupo)
      ' if(r>1.0+3.0/uR){ float g=exp(-d*7.5)*0.42+exp(-d*28.0)*0.45; gl_FragColor=vec4(uAt*g,g); return; }',
      ' float x2=sqrt(max(0.0,1.0-min(r,1.0)*min(r,1.0))); float y2=p.x; float z2=p.y;',
      ' float x=x2*uCp+z2*uSp; float z=z2*uCp-x2*uSp; float y=y2;',
      ' float t=(atan(y,x)+uLon)/(2.0*PI)+0.5; float v=0.5-asin(clamp(z,-1.0,1.0))/PI;',
      // costura del antimeridiano: de dos coordenadas u equivalentes (la textura se repite) se usa la que no salta aquí
      der ? ' float u1=fract(t), u2=fract(t+0.5)-0.5; vec3 tex=texture2D(uTex,vec2(uMip>0.5&&fwidth(u2)<fwidth(u1)?u2:u1,v),' + (aniso ? '-0.5' : '-1.0') + ').rgb;'
        : ' vec3 tex=texture2D(uTex,vec2(fract(t),v)).rgb;',
      ' if(r>1.0){ float g=exp(-d*7.5)*0.42+exp(-d*28.0)*0.45; gl_FragColor=vec4(uAt*g,g); return; }',
      ' vec3 col=mix(vec3(0.05,0.15,0.28),tex,uHas);',
      ' vec3 n=vec3(y2,z2,x2); vec3 Lg=normalize(vec3(-0.5,0.4,0.78));',
      ' float diff=max(dot(n,Lg),0.0);',
      ' col*=0.2+1.0*diff;',
      ' float ocean=smoothstep(0.015,0.1,col.b-max(col.r,col.g));',
      ' vec3 H=normalize(Lg+vec3(0.0,0.0,1.0));',
      ' col+=pow(max(dot(n,H),0.0),55.0)*0.5*ocean*vec3(0.85,0.93,1.0);',
      ' float rim=pow(1.0-x2,2.4);',
      ' col=mix(col,uAt,clamp(rim*0.8,0.0,1.0));',
      ' float aa=smoothstep(1.0-2.0/uR,1.0,r);',
      ' gl_FragColor=vec4(mix(col,uAt*0.87,aa),1.0);',
      '}'].join('\n');
    const mk = (t, src) => { const s = gl.createShader(t); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) console.warn(gl.getShaderInfoLog(s)); return s; };
    const pr = gl.createProgram(); gl.attachShader(pr, mk(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, mk(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr); gl.useProgram(pr);
    const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const U = (n) => gl.getUniformLocation(pr, n);
    const u = { C: U('uC'), R: U('uR'), Cp: U('uCp'), Sp: U('uSp'), Lon: U('uLon'), At: U('uAt'), Has: U('uHas'), Tex: U('uTex'), Mip: U('uMip') };
    const tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([14, 40, 76, 255]));
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    let has = 0, mip = 0;
    const img = new Image();
    img.onload = () => {
      gl.bindTexture(gl.TEXTURE_2D, tex); gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      // WebGL 1 solo hace mipmaps y repite texturas con lados potencia de 2 (la del globo es 4096×2048)
      const pot = (n) => n > 0 && (n & (n - 1)) === 0;
      if (der && pot(img.naturalWidth) && pot(img.naturalHeight)) {
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
        if (aniso) gl.texParameterf(gl.TEXTURE_2D, aniso.TEXTURE_MAX_ANISOTROPY_EXT, maxAniso);
        mip = 1;
      }
      has = 1; dirty = true;
    };
    img.src = (opciones.base || '') + '/images/texturas/tierra-blue-marble.jpg';
    return {
      draw() {
        gl.viewport(0, 0, cvGL.width, cvGL.height); gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
        const p0 = -V.lat * D2R;
        gl.uniform2f(u.C, V.cx * L.dpr, (L.sh - V.cy) * L.dpr); gl.uniform1f(u.R, V.R * L.dpr);
        gl.uniform1f(u.Cp, Math.cos(p0)); gl.uniform1f(u.Sp, Math.sin(p0)); gl.uniform1f(u.Lon, V.lon * D2R);
        gl.uniform3f(u.At, 0.42, 0.69, 1.0); gl.uniform1f(u.Has, has); gl.uniform1i(u.Tex, 0); gl.uniform1f(u.Mip, mip);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
      },
      clear() { gl.viewport(0, 0, cvGL.width, cvGL.height); gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); }
    };
  })();

  /* ---------- globo ilustrado (Canvas 2D + d3, acuarela como el logo) ---------- */
  let WORLD = null, waterTex = null, greenTex = null, pidioWorld = false;
  // world-atlas 110m viene del bundle (chunk aparte) y solo se descarga la primera vez que se usa el estilo ilustrado.
  function cargarWorld() {
    if (pidioWorld) return;
    pidioWorld = true;
    import('world-atlas/countries-110m.json').then((m) => m.default).then((t) => {
      if (dead) return;
      WORLD = {
        land: topojson.feature(t, t.objects.land),
        borders: topojson.mesh(t, t.objects.countries, (a, b) => a !== b),
        grat: d3.geoGraticule10(),
        capN: d3.geoCircle().center([0, 90]).radius(22)(),
        capS: d3.geoCircle().center([0, -90]).radius(29)()
      };
      dirty = true;
    }).catch((e) => console.warn('world-atlas', e));
  }

  function rgba(hex, a) { const n = parseInt(hex.slice(1), 16); return 'rgba(' + (n >> 16) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')'; }
  function blobTex(size, colors, n, rmin, rmax, amin, amax, seed) {
    const c = document.createElement('canvas'); c.width = c.height = size; const x = c.getContext('2d');
    let s = seed; const rnd = () => (s = (s * 16807) % 2147483647) / 2147483647;
    for (let i = 0; i < n; i++) {
      const px = rnd() * size, py = rnd() * size, r = rmin + rnd() * (rmax - rmin), col = colors[Math.floor(rnd() * colors.length)], a = amin + rnd() * (amax - amin);
      const g = x.createRadialGradient(px, py, 0, px, py, r);
      g.addColorStop(0, rgba(col, a)); g.addColorStop(0.65, rgba(col, a * 0.55)); g.addColorStop(1, rgba(col, 0));
      x.fillStyle = g; x.fillRect(px - r, py - r, 2 * r, 2 * r);
    }
    for (let i = 0; i < n * 3; i++) { x.fillStyle = 'rgba(255,255,255,' + (rnd() * 0.12) + ')'; x.fillRect(rnd() * size, rnd() * size, 1.5, 1.5); }
    return c;
  }
  function paperTile() {
    const c = document.createElement('canvas'); c.width = c.height = 160; const x = c.getContext('2d');
    let s = 5; const rnd = () => (s = (s * 16807) % 2147483647) / 2147483647;
    for (let i = 0; i < 900; i++) { x.fillStyle = 'rgba(90,70,40,' + (rnd() * 0.06) + ')'; x.fillRect(rnd() * 160, rnd() * 160, 1, 1); }
    return c.toDataURL();
  }
  function ensureIlluTex() {
    cargarWorld();
    if (waterTex) return;
    waterTex = blobTex(1024, ['#c9edf5', '#98d5e9', '#5aa9d0', '#7fc5df', '#3f8fbf'], 150, 40, 230, 0.10, 0.26, 11);
    greenTex = blobTex(1024, ['#c4df90', '#86bf68', '#5d9a50', '#d9e6a0', '#9ccd7b', '#4f8a47'], 260, 18, 150, 0.14, 0.34, 23);
    app.style.setProperty('--paper', 'url(' + paperTile() + ')');
  }
  function drawIllu() {
    if (!L.sw) return;
    const x = cvIllu.getContext('2d'); x.setTransform(L.dpr, 0, 0, L.dpr, 0, 0); x.clearRect(0, 0, L.sw, L.sh);
    if (S.estilo !== 'ilustrado') return;
    ensureIlluTex();
    const cx = V.cx, cy = V.cy, R = V.R;
    if (R < L.view.h * 0.62) {
      x.save(); x.translate(cx + R * 0.06, cy + R * 1.07); x.scale(1, 0.14);
      const sg = x.createRadialGradient(0, 0, 0, 0, 0, R * 0.95); sg.addColorStop(0, 'rgba(70,52,28,0.28)'); sg.addColorStop(1, 'rgba(70,52,28,0)');
      x.fillStyle = sg; x.beginPath(); x.arc(0, 0, R * 0.95, 0, 6.3); x.fill(); x.restore();
    }
    x.beginPath(); x.arc(cx, cy, R, 0, Math.PI * 2);
    const og = x.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.05, cx, cy, R * 1.02);
    og.addColorStop(0, '#b9e4f0'); og.addColorStop(0.55, '#7cc3dd'); og.addColorStop(1, '#3f90bd');
    x.fillStyle = og; x.fill();
    x.save(); x.beginPath(); x.arc(cx, cy, R, 0, Math.PI * 2); x.clip();
    x.globalAlpha = 0.65; x.drawImage(waterTex, cx - R, cy - R, 2 * R, 2 * R); x.globalAlpha = 1;
    if (WORLD) {
      const prec = drag || tween ? 0.9 : 0.35;
      const proj = d3.geoOrthographic().rotate([-V.lon, -V.lat]).scale(R).translate([cx, cy]).clipAngle(90).precision(prec);
      const path = d3.geoPath(proj, x);
      x.beginPath(); path(WORLD.grat); x.strokeStyle = 'rgba(255,255,255,0.24)'; x.lineWidth = 0.8; x.setLineDash([2, 4]); x.stroke(); x.setLineDash([]);
      x.lineJoin = 'round'; x.lineCap = 'round';
      x.beginPath(); path(WORLD.land);
      x.strokeStyle = 'rgba(238,249,247,0.6)'; x.lineWidth = clamp(R * 0.014, 4, 9); x.stroke();
      x.fillStyle = '#9dca7e'; x.fill();
      x.save(); x.clip();
      x.globalAlpha = 0.85; x.drawImage(greenTex, cx - R, cy - R, 2 * R, 2 * R); x.globalAlpha = 1;
      x.beginPath(); path(WORLD.capN); path(WORLD.capS); x.fillStyle = 'rgba(245,250,247,0.88)'; x.fill();
      x.restore();
      x.beginPath(); path(WORLD.borders); x.strokeStyle = 'rgba(255,255,255,0.55)'; x.lineWidth = 0.7; x.stroke();
      x.beginPath(); path(WORLD.land); x.strokeStyle = 'rgba(46,96,60,0.55)'; x.lineWidth = 1.1; x.stroke();
    }
    const sh = x.createRadialGradient(cx - R * 0.32, cy - R * 0.38, R * 0.08, cx, cy, R);
    sh.addColorStop(0, 'rgba(255,255,255,0.22)'); sh.addColorStop(0.5, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(16,52,78,0.30)');
    x.fillStyle = sh; x.fillRect(cx - R, cy - R, 2 * R, 2 * R);
    x.restore();
    x.beginPath(); x.arc(cx, cy, R, 0, Math.PI * 2); x.strokeStyle = 'rgba(20,35,45,0.38)'; x.lineWidth = 1.3; x.stroke();
  }

  /* ---------- capa de efectos: pulsos, rutas, líneas guía ---------- */
  function ring(x, px, py, t, rgb, maxR) {
    for (let k = 0; k < 2; k++) {
      const ph = (t * 0.55 + k * 0.5) % 1;
      x.beginPath(); x.arc(px, py, 6 + ph * maxR, 0, 6.3);
      x.strokeStyle = 'rgba(' + rgb + ',' + ((1 - ph) * 0.7).toFixed(3) + ')'; x.lineWidth = 1.6; x.stroke();
    }
  }
  function arc(x, a, b) {
    const it = d3.geoInterpolate([a.lng, a.lat], [b.lng, b.lat]), dist = d3.geoDistance([a.lng, a.lat], [b.lng, b.lat]);
    const N = 36; let on = false; x.beginPath();
    for (let i = 0; i <= N; i++) {
      const t = i / N, q = it(t), p = project(q[0], q[1], 1 + Math.sin(Math.PI * t) * dist * 0.35);
      if (p.v < -0.02) { on = false; continue; }
      if (!on) { x.moveTo(p.x, p.y); on = true; } else x.lineTo(p.x, p.y);
    }
    x.stroke();
  }
  function drawFx(t) {
    const x = cvFx.getContext('2d'); x.setTransform(L.dpr, 0, 0, L.dpr, 0, 0); x.clearRect(0, 0, L.sw, L.sh);
    const real = S.estilo === 'realista', acc = real ? '244,196,107' : '217,101,59', line = real ? 'rgba(255,255,255,0.75)' : 'rgba(20,35,45,0.55)';
    const guide = (P, rgb) => {
      if (!P || P.alpha < 0.03 || P.px == null) return;
      const dd = Math.hypot(P.cx - P.px, P.cy - P.py);
      if (dd > 10) { x.globalAlpha = P.alpha; x.strokeStyle = line; x.lineWidth = 1.1; x.beginPath(); x.moveTo(P.px, P.py); x.lineTo(P.cx, P.cy); x.stroke(); x.globalAlpha = 1; }
      x.fillStyle = '#fff'; x.strokeStyle = 'rgb(' + rgb + ')'; x.lineWidth = 2; x.globalAlpha = P.alpha; x.beginPath(); x.arc(P.px, P.py, 3.5, 0, 6.3); x.fill(); x.stroke(); x.globalAlpha = 1;
    };
    if (S.modo === 'viajes' && S.nivel === 'mundo') {
      D.viajes.forEach((v, i) => { const p = project(v.lng, v.lat); if (p.v > 0.12 && enAnio(v)) ring(x, p.x, p.y, t + i * 0.37, acc, 30); guide(PINS.trip[v.id], acc); });
    }
    if (S.modo === 'viajes' && S.viaje) {
      x.save(); x.setLineDash([6, 7]); x.lineDashOffset = -t * 26; x.strokeStyle = 'rgba(' + acc + ',0.95)'; x.lineWidth = 2.2; x.lineCap = 'round';
      for (let i = 0; i < paradas.length - 1; i++) arc(x, D.destinos[paradas[i]], D.destinos[paradas[i + 1]]);
      x.restore();
      paradas.forEach((id) => {
        const d = D.destinos[id], p = project(d.lng, d.lat); if (p.v < 0) return;
        const P = PINS.dest[id];
        if (S.nivel === 'viaje' && P && P.alpha > 0.05) {
          x.globalAlpha = P.alpha; x.strokeStyle = line; x.lineWidth = 1.2;
          x.beginPath(); x.moveTo(p.x, p.y); x.lineTo(P.cx, P.cy); x.stroke(); x.globalAlpha = 1;
        }
        x.fillStyle = '#fff'; x.strokeStyle = 'rgb(' + acc + ')'; x.lineWidth = 2.5;
        x.beginPath(); x.arc(p.x, p.y, 4.5, 0, 6.3); x.fill(); x.stroke();
        if (S.dest === id) ring(x, p.x, p.y, t, acc, 46);
      });
    }
    if (S.modo === 'viajeros') {
      D.lugaresViajeros.forEach((l, i) => { const p = project(l.lng, l.lat); if (p.v > 0.12 && (!S.lugar || S.lugar === l.id)) ring(x, p.x, p.y, t + i * 0.5, '236,98,120', 30); guide(PINS.place[l.id], '236,98,120'); });
    }
  }

  /* ---------- pines (DOM) ---------- */
  /**
   * Pin del DOM y su estado por cuadro.
   * @typedef {Object} PinDom
   * @property {HTMLElement} el
   * @property {number} cx      posición dibujada
   * @property {number} cy
   * @property {number} tx      lugar que le toca en el anillo de paradas (pines de parada)
   * @property {number} ty
   * @property {?number} px     punto real en el globo (líneas guía); null hasta el primer cuadro
   * @property {?number} py
   * @property {number} dx      celular: desplazamiento suavizado respecto al punto real
   * @property {number} dy
   * @property {number} alpha   opacidad actual (0 = oculto)
   * @property {boolean} on
   * @property {boolean} init
   * @property {string} op      última opacidad escrita en el DOM
   * @property {string} zi      última capa (z-index) escrita en el DOM
   * @property {?string} lbl    celular: posición de la etiqueta ('abajo', 'derecha', 'izquierda', 'arriba') o null si no cabe
   * @property {number} medio   escritorio: medio ancho de la caja del pin con su etiqueta
   * @property {number} lw      celular: ancho de la etiqueta
   * @property {number} lh      celular: alto de la etiqueta
   * @property {number} fw      ancho de la foto o de la pila de fotos
   * @property {number} fh      alto de la foto
   */
  /** @type {{trip: Object<string, PinDom>, dest: Object<string, PinDom>, place: Object<string, PinDom>}} */
  const PINS = { trip: {}, dest: {}, place: {} };
  /** @returns {PinDom} */
  function mkPin(kind, id, html, label, onClick) {
    const el = document.createElement('div'); el.className = 'pin ' + kind;
    // viajes y viajeros: en el celular la etiqueta empieza oculta hasta que colocarEtiquetas() le encuentra lugar
    if (kind !== 'dest') el.dataset.lbl = 'no';
    el.innerHTML = '<button class="pin-in" aria-label="' + esc(label) + '">' + html + '</button>';
    const b = el.firstChild;
    b.addEventListener('click', (e) => { e.stopPropagation(); conGloboQuieto(onClick, true); });
    b.addEventListener('mouseenter', () => { S.hover = id; }); b.addEventListener('mouseleave', () => { if (S.hover === id) S.hover = null; });
    pinsEl.appendChild(el);
    return { el, cx: 0, cy: 0, tx: 0, ty: 0, px: null, py: null, dx: 0, dy: 0, alpha: 0, on: false, init: false, op: '', zi: '', lbl: null, medio: 0, lw: 0, lh: 0, fw: 0, fh: 0 };
  }
  D.viajes.forEach((v) => {
    PINS.trip[v.id] = mkPin('trip', v.id, '<span class="phw"><span class="ph"><img loading="lazy" decoding="async" src="' + v.portada + '" alt=""></span><span class="badge">' + v.paradas.length + '</span></span><span class="lbl">' + esc(v.nombre) + '<small>' + v.aniosTexto + '</small></span>', v.nombre + ' ' + v.aniosTexto, () => selectViaje(v.id));
  });
  destIds.forEach((id) => {
    const d = D.destinos[id], vj = tripOf(id), n = vj.paradas.indexOf(id) + 1;
    // número de parada: fijarViaje() lo ajusta (y la portada) cuando se elige un año
    PINS.dest[id] = mkPin('dest', id, '<span class="phw"><span class="ph"><img loading="lazy" decoding="async" src="' + cover(id) + '" alt=""></span><span class="badge"' + (vj.paradas.length > 1 ? '' : ' style="display:none"') + '>' + n + '</span></span><span class="lbl">' + esc(d.nombre) + '</span>', d.nombre, () => { if (S.nivel === 'destino' && S.dest === id) openLB(id, 0); else selectDest(id); });
  });
  D.lugaresViajeros.forEach((l) => {
    const rs = l.resenas.map(resena);
    PINS.place[l.id] = mkPin('place', l.id, '<span class="phw"><span class="stack">' + rs.map((r) => '<span class="ph"><img loading="lazy" decoding="async" src="' + r.micro + '" alt=""' + encuadre(r.encuadre) + '></span>').join('') + '</span><span class="badge heart"><i class="fa-solid fa-heart"></i></span></span><span class="lbl">' + esc(l.nombre) + '<small>' + quienesViajaron(l) + '</small></span>', l.nombre, () => selectLugar(l.id));
  });
  // Medidas de los pines de viaje y de viajeros. Escritorio: medio ancho de la etiqueta ("California 2024 · 2026"),
  // que relax() usa para que ninguna se corte en los bordes. Celular: tamaño de la etiqueta (solo el nombre) y de la
  // foto o pila de fotos, para separarMovil() y colocarEtiquetas().
  function medirEtiquetas() {
    [PINS.trip, PINS.place].forEach((grupo) => Object.keys(grupo).forEach((id) => {
      const P = grupo[id], lbl = P.el.querySelector('.lbl'), fotos = P.el.querySelector('.phw');
      P.medio = Math.max(40, Math.ceil((lbl ? lbl.offsetWidth : 0) / 2) + 8);
      P.lw = lbl ? lbl.offsetWidth : 0; P.lh = lbl ? lbl.offsetHeight : 0;
      P.fw = fotos ? fotos.offsetWidth : 0; P.fh = fotos ? fotos.offsetHeight : 0;
    }));
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (!dead) medirEtiquetas(); });
  // Solo se escribe en el DOM lo que cambió: un pin oculto no se mueve y opacidad/capa se tocan solo al cambiar.
  function setPin(P, x, y, show, alpha) {
    if (!show && !P.on && P.op === '0') return;
    P.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
    const op = show ? alpha.toFixed(3) : '0', zi = show ? String(Math.round(10 + alpha * 10)) : '0';
    if (op !== P.op) { P.op = op; P.el.style.opacity = op; }
    if (zi !== P.zi) { P.zi = zi; P.el.style.zIndex = zi; }
    if (show !== P.on) { P.on = show; P.el.classList.toggle('on', show); }
    P.alpha = show ? alpha : 0;
  }
  function computeRing(ids) {
    const n = ids.length, vw = L.view;
    const pts = ids.map((id) => { const d = D.destinos[id]; return project(d.lng, d.lat); });
    if (n === 1) { const P = PINS.dest[ids[0]]; P.tx = pts[0].x; P.ty = pts[0].y - (L.movil ? 70 : 96); return; }
    const c = pts.reduce((a, p) => ({ x: a.x + p.x / n, y: a.y + p.y / n }), { x: 0, y: 0 });
    const base = Math.min(vw.w, vw.h), rx = clamp(base * ((L.movil ? 0.3 : 0.25) + n * 0.013), 118, 300), ry = rx * 0.8;
    const slots = []; const st = -Math.PI / 2 + (n % 2 ? 0 : Math.PI / n);
    for (let k = 0; k < n; k++) slots.push(st + k * 2 * Math.PI / n);
    const spread = Math.max.apply(null, pts.map((p) => Math.hypot(p.x - c.x, p.y - c.y)));
    let order = ids.map((_, i) => i);
    if (spread > 14) {
      const nat = pts.map((p, i) => ({ i, a: Math.atan2(p.y - c.y, p.x - c.x) })).sort((a, b) => a.a - b.a);
      const sl = slots.map((a, k) => ({ a: Math.atan2(Math.sin(a), Math.cos(a)), k })).sort((a, b) => a.a - b.a);
      let best = 0, bc = Infinity;
      for (let r = 0; r < n; r++) {
        let cost = 0;
        for (let j = 0; j < n; j++) { const da = nat[j].a - sl[(j + r) % n].a; const w = Math.atan2(Math.sin(da), Math.cos(da)); cost += w * w; }
        if (cost < bc) { bc = cost; best = r; }
      }
      order = new Array(n);
      for (let j = 0; j < n; j++) order[sl[(j + best) % n].k] = nat[j].i;
    }
    for (let k = 0; k < n; k++) {
      const P = PINS.dest[ids[order[k]]], a = slots[k];
      P.tx = clamp(c.x + Math.cos(a) * rx, vw.x + 56, vw.x + vw.w - 56);
      P.ty = clamp(c.y + Math.sin(a) * ry, vw.y + (L.movil ? 56 : 70), vw.y + vw.h - 64);
    }
  }
  // Separa los pines encimados y los mantiene dentro del escenario (con su etiqueta completa y sin tapar el selector de modo).
  // Cada pin ocupa una "caja": su foto con la insignia (alto) y su etiqueta (medio ancho o.m).
  // Se separan las cajas que se enciman usando una superelipse (casi un rectángulo, pero continua,
  // para que los pines no brinquen mientras gira el globo) y se mantienen dentro del escenario.
  function relax(items, alto) {
    // arriba: en escritorio, debajo del selector de modo (en móvil va arriba de la lista); abajo: en móvil, la
    // etiqueta no baja hasta el aviso "Desliza a los lados para girar"
    const vw = L.view, y0 = vw.y + (L.movil ? 56 : 70), y1 = vw.y + vw.h - (L.movil ? 110 : 66);
    for (let it = 0; it < 24; it++) {
      items.forEach((o) => { o.x += (o.ox - o.x) * 0.05; o.y += (o.oy - o.y) * 0.05; });
      for (let i = 0; i < items.length; i++) for (let j = i + 1; j < items.length; j++) {
        const a = items[i], b = items[j]; if (!a.vis || !b.vis) continue;
        const W = a.m + b.m + 8, dx = b.x - a.x, dy = b.y - a.y;
        const ux = Math.abs(dx) / W, uy = Math.abs(dy) / alto, f = ux ** 4 + uy ** 4;
        if (f >= 1) continue;
        // Se empuja hacia donde ya están más separadas (gradiente de la superelipse): es lo que menos las mueve.
        let gx = (dx < 0 ? -1 : 1) * ux ** 3 / W, gy = (dy < 0 ? -1 : 1) * uy ** 3 / alto;
        if (f < 1e-6) { gx = 0; gy = 1; }
        const g = Math.hypot(gx, gy); gx /= g; gy /= g;
        const empuje = (1 - Math.sqrt(Math.sqrt(f))) * (Math.abs(gx) * W + Math.abs(gy) * alto) / 2;
        a.x -= gx * empuje; a.y -= gy * empuje; b.x += gx * empuje; b.y += gy * empuje;
      }
      items.forEach((o) => { if (o.vis) { o.x = clamp(o.x, vw.x + o.m, vw.x + vw.w - o.m); o.y = clamp(o.y, y0, y1); } });
    }
  }
  /**
   * Pin de viaje o de viajeros en un cuadro: su punto real en el globo (ox, oy) y dónde lo deja el acomodo (x, y).
   * @typedef {Object} PinItem
   * @property {string} id
   * @property {number} ox   punto real proyectado
   * @property {number} oy
   * @property {number} x    posición acomodada
   * @property {number} y
   * @property {number} v    orientación hacia la cámara (1 al centro, 0 en el borde, negativo atrás)
   * @property {boolean} vis se acomoda (está del lado visible y, en viajes, tiene fotos del año elegido)
   * @property {number} w    celular: qué tanto se ve (0 a 1); un pin que va apareciendo empuja menos
   * @property {number} m    medio ancho de su caja (escritorio: con etiqueta; celular: solo la foto)
   * @property {number} h    celular: alto de su caja (la foto)
   * @property {boolean} [conAnio]  viajes: tiene fotos del año elegido
   */
  // Celular: los pines de viajes y viajeros se separan solo por su foto (la etiqueta se acomoda aparte, en
  // colocarEtiquetas) y cada par se empuja en la dirección en que están de verdad en el globo, así que nunca se
  // cruzan y quedan a unos 20 px de su punto como mucho. Un pin que va apareciendo en el borde empuja según cuánto se ve.
  function separarMovil(items) {
    const vw = L.view, y0 = vw.y + 26, y1 = vw.y + vw.h - 26;
    for (let it = 0; it < 24; it++) {
      items.forEach((o) => { o.x += (o.ox - o.x) * 0.05; o.y += (o.oy - o.y) * 0.05; });
      for (let i = 0; i < items.length; i++) for (let j = i + 1; j < items.length; j++) {
        const a = items[i], b = items[j]; if (!a.vis || !b.vis) continue;
        const W = a.m * a.w + b.m * b.w + 4, H = (a.h + b.h) / 2 * Math.min(a.w, b.w) + 1e-6;
        const ux = Math.abs(b.x - a.x) / W, uy = Math.abs(b.y - a.y) / H, f = ux ** 4 + uy ** 4;
        if (f >= 1) continue;
        // dirección: la del desplazamiento real entre los dos puntos (gradiente de la superelipse), no la actual
        const rx = b.ox - a.ox, ry = b.oy - a.oy;
        let gx = (rx < 0 ? -1 : 1) * (Math.abs(rx) / W) ** 3 / W, gy = (ry < 0 ? -1 : 1) * (Math.abs(ry) / H) ** 3 / H;
        if (Math.hypot(gx, gy) < 1e-12) { gx = 0; gy = 1; }
        const g = Math.hypot(gx, gy); gx /= g; gy /= g;
        const empuje = (1 - Math.sqrt(Math.sqrt(f))) * (Math.abs(gx) * W + Math.abs(gy) * H) / 2;
        a.x -= gx * empuje; a.y -= gy * empuje; b.x += gx * empuje; b.y += gy * empuje;
      }
      items.forEach((o) => { if (o.vis) { o.x = clamp(o.x, vw.x + o.m, vw.x + vw.w - o.m); o.y = clamp(o.y, y0, y1); } });
    }
  }
  // Celular: el pin sigue exacto a su punto del globo y solo el desplazamiento del acomodo se suaviza (no brinca cuando
  // otro pin aparece o se va); un pin que recién aparece toma su desplazamiento de una vez.
  function seguir(P, o, show, k) {
    const tx = o.x - o.ox, ty = o.y - o.oy;
    if (!show || !P.on) { P.dx = tx; P.dy = ty; } else { P.dx += (tx - P.dx) * k; P.dy += (ty - P.dy) * k; }
    P.cx = o.ox + P.dx; P.cy = o.oy + P.dy;
  }
  const POS_ETIQUETA = ['abajo', 'derecha', 'izquierda', 'arriba'];
  const choca = (a, b, margen) => a.x0 < b.x1 + margen && b.x0 < a.x1 + margen && a.y0 < b.y1 + margen && b.y0 < a.y1 + margen;
  // Caja de la etiqueta de un pin en cada posición (mismas medidas que el CSS de .mm.movil .pin[data-lbl])
  function cajaEtiqueta(P, pos) {
    const x = P.cx, y = P.cy, hw = P.fw / 2, hh = P.fh / 2;
    if (pos === 'abajo') return { x0: x - P.lw / 2, x1: x + P.lw / 2, y0: y + hh + 5, y1: y + hh + 5 + P.lh };
    if (pos === 'arriba') return { x0: x - P.lw / 2, x1: x + P.lw / 2, y0: y - hh - 9 - P.lh, y1: y - hh - 9 };
    if (pos === 'derecha') return { x0: x + hw + 9, x1: x + hw + 9 + P.lw, y0: y - P.lh / 2, y1: y + P.lh / 2 };
    return { x0: x - hw - 5 - P.lw, x1: x - hw - 5, y0: y - P.lh / 2, y1: y + P.lh / 2 };
  }
  /**
   * Celular: pone la etiqueta (solo el nombre) de cada pin de viaje o de viajeros alrededor de su foto, en el orden de
   * los datos. Se queda donde estaba mientras siga libre; si no, toma la primera posición libre (abajo, derecha,
   * izquierda, arriba) que no pise otra foto, otra etiqueta, el borde del escenario ni el aviso; si ninguna cabe, se
   * oculta (el pin se sigue pudiendo tocar y la lista de arriba lo nombra). Solo toca el DOM cuando cambia.
   * @param {PinItem[]} items
   * @param {Object<string, PinDom>} grupo
   */
  function colocarEtiquetas(items, grupo) {
    const vw = L.view, aviso = hint.classList.contains('fuera') ? null : L.aviso;
    const visibles = items.filter((o) => grupo[o.id].on && grupo[o.id].alpha > 0.5);
    const fotos = visibles.map((o) => { const P = grupo[o.id]; return { id: o.id, x0: P.cx - P.fw / 2, x1: P.cx + P.fw / 2 + 6, y0: P.cy - P.fh / 2 - 6, y1: P.cy + P.fh / 2 }; });
    const puestas = [];
    const libre = (r, id, margen) => r.x0 >= vw.x + 4 && r.x1 <= vw.x + vw.w - 4 && r.y0 >= vw.y + 4 && r.y1 <= vw.y + vw.h - 4 &&
      (!aviso || !choca(r, aviso, 0)) && fotos.every((f) => f.id === id || !choca(r, f, margen)) && puestas.every((q) => !choca(r, q, margen));
    items.forEach((o) => {
      const P = grupo[o.id];
      let pos = null;
      if (visibles.indexOf(o) >= 0) {
        if (P.lbl && libre(cajaEtiqueta(P, P.lbl), o.id, 0)) pos = P.lbl;
        else pos = POS_ETIQUETA.find((c) => libre(cajaEtiqueta(P, c), o.id, 3)) || null;
        if (pos) puestas.push(cajaEtiqueta(P, pos));
      }
      if (pos !== P.lbl) { P.lbl = pos; P.el.dataset.lbl = pos || 'no'; }
    });
  }
  function updatePins(dt) {
    const k = 1 - Math.exp(-dt * 8.5);
    const mundoV = S.modo === 'viajes' && S.nivel === 'mundo';
    // con un año elegido, solo se ven (y se separan entre sí) los viajes que tienen fotos de ese año
    const tItems = D.viajes.map((v) => {
      const p = project(v.lng, v.lat), conAnio = enAnio(v), P = PINS.trip[v.id];
      return { id: v.id, ox: p.x, oy: p.y, x: p.x, y: p.y, v: p.v, conAnio, vis: conAnio && p.v > 0.08, w: clamp((p.v - 0.06) * 6, 0, 1), m: L.movil ? (P.fw || 42) / 2 + 3 : P.medio || 62, h: (P.fh || 42) + 6 };
    });
    if (mundoV) { if (L.movil) separarMovil(tItems); else relax(tItems, 102); }
    tItems.forEach((o) => {
      const P = PINS.trip[o.id], vis = clamp((o.v - 0.06) * 6, 0, 1), show = mundoV && o.conAnio && vis > 0.02;
      P.px = o.ox; P.py = o.oy;
      if (L.movil) seguir(P, o, show, k); else { P.cx = o.x; P.cy = o.y; }
      setPin(P, P.cx, P.cy, show, vis);
    });
    if (L.movil && mundoV) colocarEtiquetas(tItems, PINS.trip);
    const vj = S.viaje ? D.viajes.find((v) => v.id === S.viaje) : null;
    if (vj && S.modo === 'viajes') computeRing(paradas);
    destIds.forEach((id) => {
      const P = PINS.dest[id];
      const show = !!vj && S.modo === 'viajes' && paradas.indexOf(id) >= 0 && (S.nivel === 'viaje' || (S.nivel === 'destino' && S.dest === id));
      if (!show) { if (P.on) setPin(P, P.cx, P.cy, false, 0); P.init = false; return; }
      const d = D.destinos[id], p = project(d.lng, d.lat);
      if (S.nivel === 'destino') { P.tx = p.x; P.ty = p.y; }
      if (!P.init) { P.cx = S.spawn ? S.spawn.x : p.x; P.cy = S.spawn ? S.spawn.y : p.y; P.init = true; }
      P.cx += (P.tx - P.cx) * k; P.cy += (P.ty - P.cy) * k;
      P.el.classList.toggle('big', S.nivel === 'destino');
      setPin(P, P.cx, P.cy, true, clamp((p.v + 0.2) * 3, 0, 1));
    });
    const viajeros = S.modo === 'viajeros';
    const pItems = D.lugaresViajeros.map((l) => {
      const p = project(l.lng, l.lat), P = PINS.place[l.id];
      return { id: l.id, ox: p.x, oy: p.y, x: p.x, y: p.y, v: p.v, vis: p.v > 0.08 && (!S.lugar || S.lugar === l.id), w: clamp((p.v - 0.06) * 6, 0, 1), m: L.movil ? (P.fw || 42) / 2 + 3 : P.medio || 84, h: (P.fh || 42) + 6 };
    });
    if (viajeros) { if (L.movil) separarMovil(pItems); else relax(pItems, 90); }
    pItems.forEach((o) => {
      const P = PINS.place[o.id], vis = clamp((o.v - 0.06) * 6, 0, 1), show = viajeros && o.vis && vis > 0.02;
      P.px = o.ox; P.py = o.oy;
      if (L.movil) seguir(P, o, show, k); else { P.cx = o.x; P.cy = o.y; }
      setPin(P, P.cx, P.cy, show, vis);
    });
    if (L.movil && viajeros) colocarEtiquetas(pItems, PINS.place);
  }

  /* ---------- polaroids ---------- */
  function polaSlots(n, o, key, big) {
    const vw = L.view, m = L.movil;
    let s = hash(key); const rnd = () => (s = (s * 16807) % 2147483647) / 2147483647;
    const w = Math.round(big ? clamp(Math.min(vw.w, vw.h) * (m ? 0.36 : 0.25), 130, 220) : clamp(Math.min(vw.w, vw.h) * (m ? 0.3 : 0.205), 104, 186));
    const h = Math.round(w * 1.25 + 8 + 54);
    const rx = Math.max(40, Math.min(vw.w * 0.5 - w * 0.55 - 10, (m ? 0.5 : 0.35) * vw.w));
    const ry = Math.max(40, Math.min(vw.h * 0.5 - h * 0.48 - 12, 0.3 * vw.h + 40));
    const out = [];
    let angs;
    if (big) angs = n === 1 ? [-Math.PI / 4] : [-Math.PI * 0.78, -Math.PI * 0.22, Math.PI / 2];
    else { angs = []; const st = -Math.PI / 2 - Math.PI / n; for (let j = 0; j < n; j++) angs.push(st + j * 2 * Math.PI / n + (rnd() - 0.5) * 0.22); }
    for (let j = 0; j < n; j++) {
      const a = angs[j % angs.length];
      let x = o.x + Math.cos(a) * rx * (0.92 + rnd() * 0.12), y = o.y + Math.sin(a) * ry * (0.9 + rnd() * 0.14);
      x = clamp(x, vw.x + w / 2 + (m ? 10 : 44), vw.x + vw.w - w / 2 - 10); y = clamp(y, vw.y + h / 2 + (m ? 16 : 74), vw.y + vw.h - h / 2 - 12);
      out.push({ x, y, w, h, r: ((rnd() - 0.5) * 14).toFixed(2) });
    }
    return out;
  }
  /**
   * Polaroid a mostrar alrededor de un punto del globo.
   * @typedef {Object} PolaroidSpec
   * @property {string} src          foto (versión mini)
   * @property {string} cap          pie escrito a mano
   * @property {string} [pos]        encuadre de la foto (CSS object-position); si falta, el centro
   * @property {() => void} [onClick]
   */
  let polaSpec = null;
  /** @param {PolaroidSpec[]} list */
  function spawnPolas(list, origin, key, big) {
    clearPolas(null, true);
    polaSpec = { list, key, big };
    const slots = polaSlots(list.length, origin, key, big);
    list.forEach((f, j) => {
      const s = slots[j], el = document.createElement('div');
      el.className = 'pola' + (f.onClick ? '' : ' plain');
      el.style.setProperty('--w', s.w + 'px'); el.style.setProperty('--r', s.r + 'deg'); el.style.zIndex = 10 + j;
      el.innerHTML = '<figure class="pola-in"><div class="pola-img"><img src="' + f.src + '" alt="' + esc(f.cap) + '" draggable="false"' + encuadre(f.pos) + '></div><figcaption class="pola-cap">' + esc(f.cap) + '</figcaption></figure>';
      if (f.onClick) el.addEventListener('click', (e) => { e.stopPropagation(); f.onClick(); });
      polasEl.appendChild(el);
      const to = 'translate(' + (s.x - s.w / 2).toFixed(1) + 'px,' + (s.y - s.h / 2).toFixed(1) + 'px) scale(1)';
      const from = 'translate(' + (origin.x - s.w / 2).toFixed(1) + 'px,' + (origin.y - s.h / 2).toFixed(1) + 'px) scale(0.12)';
      el.style.transform = to;
      if (!REDUCE) el.animate([{ transform: from, opacity: 0 }, { transform: to, opacity: 1 }], { duration: 780, delay: 80 + j * 80, easing: 'cubic-bezier(.2,1.15,.35,1)', fill: 'backwards' });
      polas.push({ el, s });
    });
  }
  // Las polaroids que se van ya no reciben clics (clase saliendo) y se quitan al terminar su animación;
  // el setTimeout de respaldo las quita aunque la animación se atrase en un equipo lento.
  function clearPolas(to, instant) {
    const old = polas; polas = []; polaSpec = null;
    old.forEach((p, j) => {
      p.el.classList.add('saliendo');
      const quitar = () => p.el.remove();
      let dura;
      if (instant || !to || REDUCE) {
        dura = instant ? 160 : 250;
        p.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dura, fill: 'forwards' }).onfinish = quitar;
      } else {
        dura = 440 + j * 35;
        p.el.animate([{ transform: p.el.style.transform, opacity: 1 }, { transform: 'translate(' + (to.x - p.s.w / 2) + 'px,' + (to.y - p.s.h / 2) + 'px) scale(0.1)', opacity: 0 }], { duration: 440, delay: j * 35, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }).onfinish = quitar;
      }
      setTimeout(quitar, dura + 120);
    });
  }
  function respawnPolas() {
    if (!polaSpec) return;
    const spec = polaSpec, o = { x: V.cx, y: V.cy };
    polas.forEach((p) => p.el.remove()); polas = [];
    const slots = polaSlots(spec.list.length, o, spec.key, spec.big);
    spec.list.forEach((f, j) => {
      const s = slots[j], el = document.createElement('div');
      el.className = 'pola' + (f.onClick ? '' : ' plain');
      el.style.setProperty('--w', s.w + 'px'); el.style.setProperty('--r', s.r + 'deg'); el.style.zIndex = 10 + j;
      el.innerHTML = '<figure class="pola-in"><div class="pola-img"><img src="' + f.src + '" alt=""' + encuadre(f.pos) + '></div><figcaption class="pola-cap">' + esc(f.cap) + '</figcaption></figure>';
      if (f.onClick) el.addEventListener('click', (e) => { e.stopPropagation(); f.onClick(); });
      el.style.transform = 'translate(' + (s.x - s.w / 2) + 'px,' + (s.y - s.h / 2) + 'px)';
      polasEl.appendChild(el); polas.push({ el, s });
    });
    polaSpec = spec;
  }

  /* ---------- cámara ---------- */
  function flyTo(lon, lat, z, dur, done) {
    const from = { lon: V.lon, lat: V.lat, z: V.z };
    const dl = ((lon - from.lon + 540) % 360) - 180, dist = Math.hypot(dl, lat - from.lat);
    tween = { from, dl, dlat: lat - from.lat, z1: z, t0: performance.now(), dur: REDUCE ? 1 : dur * (0.75 + Math.min(1, dist / 120) * 0.45), dist, done };
    vel = { lon: 0, lat: 0 };
  }
  function stepTween(now) {
    if (!tween) return;
    // el cuadro puede traer una marca de tiempo un poco anterior a t0: sin la cota inferior la cámara daría un salto
    const t = clamp((now - tween.t0) / tween.dur, 0, 1), e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    V.lon = tween.from.lon + tween.dl * e; V.lat = tween.from.lat + tween.dlat * e;
    const zl = tween.from.z + (tween.z1 - tween.from.z) * e, dip = Math.sin(Math.PI * e) * Math.min(1, tween.dist / 70) * 0.42;
    V.z = Math.max(0.85, zl * (1 - dip));
    dirty = true;
    if (t >= 1) { const d = tween.done; tween = null; if (d) d(); }
  }

  /* ---------- acciones ---------- */
  function hideHint() { hint.classList.add('fuera'); }
  // Viaje abierto (o ninguno) y año elegido: define las paradas visibles y ajusta el número y la portada de sus pines.
  function fijarViaje(viaje, anio) {
    S.viaje = viaje; S.anio = anio;
    paradas = D.paradasDe(viaje, anio);
    // pines de viaje: su insignia cuenta las paradas con fotos del año elegido (los viajes sin ese año no se ven)
    D.viajes.forEach((v) => { PINS.trip[v.id].el.querySelector('.badge').textContent = D.paradasDe(v.id, anio).length || v.paradas.length; });
    paradas.forEach((id, i) => {
      const el = PINS.dest[id].el, im = el.querySelector('.ph img'), badge = el.querySelector('.badge'), src = cover(id, anio);
      if (im.getAttribute('src') !== src) im.src = src;
      badge.textContent = i + 1; badge.style.display = paradas.length > 1 ? '' : 'none';
    });
  }
  function selectViaje(id) {
    const vj = D.viajes.find((v) => v.id === id); if (!vj) return;
    const tp = PINS.trip[id]; S.spawn = { x: tp.cx, y: tp.cy };
    hideHint(); lastInteract = performance.now();
    const anio = enAnio(vj) ? S.anio : null; // el año elegido sigue si el viaje tiene fotos de ese año
    if (vj.paradas.length === 1) { fijarViaje(id, anio); selectDest(vj.paradas[0]); return; }
    clearPolas(null, true);
    S.modo = 'viajes'; S.nivel = 'viaje'; S.dest = null; S.lugar = null;
    fijarViaje(id, anio);
    flyTo(vj.lng, vj.lat, vj.zoom || 3.2, 1500);
    renderPanel(); syncModos();
  }
  function selectDest(id) {
    const vj = tripOf(id); if (!vj) return;
    if (S.viaje !== vj.id) { const p = project(vj.lng, vj.lat); S.spawn = { x: p.x, y: p.y }; }
    // celular: el pin del destino nuevo sale del destino anterior (mismo viaje), no de un punto viejo
    else if (L.movil && S.nivel === 'destino' && S.dest && S.dest !== id) { const a = D.destinos[S.dest], p = project(a.lng, a.lat); S.spawn = { x: p.x, y: p.y }; }
    hideHint(); lastInteract = performance.now();
    S.modo = 'viajes'; S.nivel = 'destino'; S.dest = id; S.lugar = null;
    fijarViaje(vj.id, S.anio && D.destinos[id].anios.indexOf(S.anio) >= 0 ? S.anio : null);
    clearPolas(null, true);
    const d = D.destinos[id];
    flyTo(d.lng, d.lat, vj.zoom || 3.2, 1150, () => { if (S.dest === id) polasDestino(id); });
    renderPanel(); syncModos();
  }
  // Polaroids alrededor del pin del destino: hasta 5 (móvil) o 7 fotos del año elegido, repartidas entre todas las de ese año.
  function polasDestino(id) {
    const d = D.destinos[id], p = project(d.lng, d.lat), fs = fotosDe(id, S.anio), K = Math.min(fs.length, L.movil ? 5 : 7), pick = [];
    for (let j = 0; j < K; j++) pick.push(Math.round(j * (fs.length - 1) / Math.max(1, K - 1)));
    spawnPolas(pick.map((i) => ({ src: fs[i].mini, cap: fix(fs[i].descripcion) || fs[i].titulo, onClick: () => openLB(id, i) })), { x: p.x, y: p.y }, id, false);
  }
  // Cambia el año sin salir del nivel actual: pines, ruta, polaroids y panel se actualizan.
  function setAnio(anio) {
    if (anio === S.anio) return;
    lastInteract = performance.now(); hideHint();
    fijarViaje(S.viaje, anio);
    S.spawn = null; // las paradas que aparecen salen de su propio punto en el globo
    if (S.nivel === 'destino' && !tween) polasDestino(S.dest); // si la cámara aún vuela, las polaroids salen al llegar, ya con el año nuevo
    renderPanel(true);
  }
  function backToViaje() {
    const vj = D.viajes.find((v) => v.id === S.viaje); if (!vj) return backToMundo();
    if (vj.paradas.length === 1) return backToMundo();
    const d = S.dest && D.destinos[S.dest]; if (d) { const p = project(d.lng, d.lat); clearPolas({ x: p.x, y: p.y }); }
    S.nivel = 'viaje'; S.dest = null; S.spawn = { x: V.cx, y: V.cy };
    flyTo(vj.lng, vj.lat, vj.zoom || 3.2, 900);
    renderPanel();
  }
  function backToMundo() {
    const d = S.dest && D.destinos[S.dest], l = S.lugar && D.lugaresViajeros.find((x) => x.id === S.lugar);
    const anchor = d || l; if (anchor) { const p = project(anchor.lng, anchor.lat); clearPolas({ x: p.x, y: p.y }); } else clearPolas(null, true);
    S.nivel = 'mundo'; S.dest = null; S.lugar = null;
    fijarViaje(null, S.anio); // el mundo sigue mostrando el año elegido
    flyTo(V.lon - 12, 22, 1, 1300);
    lastInteract = performance.now();
    renderPanel();
  }
  function setModo(m) {
    if (S.modo === m && S.nivel === 'mundo') return;
    clearPolas(null, true);
    S.modo = m; S.nivel = 'mundo'; S.dest = null; S.lugar = null;
    fijarViaje(null, null);
    // en el celular "Mis viajeros" deja a América más al centro: Nueva York, Orlando y California caben con su nombre
    flyTo(m === 'viajeros' ? (L.movil ? -60 : -42) : V.lon, 30, 1, 1200);
    lastInteract = performance.now(); hideHint();
    renderPanel(); syncModos();
  }
  function selectLugar(id) {
    const l = D.lugaresViajeros.find((x) => x.id === id); if (!l) return;
    clearPolas(null, true); hideHint(); lastInteract = performance.now();
    S.modo = 'viajeros'; S.nivel = 'lugar'; S.lugar = id; S.dest = null;
    fijarViaje(null, null);
    flyTo(l.lng, l.lat, 2.3, 1300, () => {
      if (S.lugar !== id) return;
      const p = project(l.lng, l.lat), rs = l.resenas.map(resena);
      spawnPolas(rs.map((r) => ({ src: r.mini, cap: r.nombre, pos: r.encuadre, onClick: () => focusReview(r.id) })), { x: p.x, y: p.y }, id, true);
    });
    renderPanel(); syncModos();
  }
  /**
   * Celular, "Ver en mi mapa" (desde Testimonios): abre el lugar de una vez y baja hasta el globo, justo bajo la barra
   * fija. El vuelo de la cámara arranca cuando el globo entra a la vista y al llegar salen las fotos de las familias.
   * En escritorio no hace nada: ahí la sección entra completa y el globo ya se ve junto al panel.
   * @param {string} lugar  id del lugar de "Mis viajeros"
   * @returns {boolean} true si se encargó (celular); false para seguir el camino de escritorio
   */
  function verLugarEnGlobo(lugar) {
    if (!L.movil || !D.lugaresViajeros.some((l) => l.id === lugar)) return false;
    selectLugar(lugar);
    const y = stage.getBoundingClientRect().top + window.scrollY - navH() - barra.offsetHeight;
    window.scrollTo({ top: Math.max(0, y), behavior: REDUCE ? 'auto' : 'smooth' });
    return true;
  }
  function focusReview(id) {
    const el = root.querySelector('#rv-' + id); if (!el) return;
    el.classList.add('abierta'); el.classList.remove('flash'); void el.offsetWidth; el.classList.add('flash');
    const mas = el.querySelector('.more'); if (mas) mas.textContent = 'Ver menos';
    const r = el.getBoundingClientRect(), arriba = navH() + barra.offsetHeight + 12; // la barra fija del celular mide 0 en escritorio
    if (r.top < arriba || r.bottom > window.innerHeight - 12) window.scrollTo({ top: r.top + window.scrollY - arriba - 8, behavior: 'smooth' });
  }
  function syncModos() { modos.querySelectorAll('button').forEach((b) => b.classList.toggle('on', b.dataset.m === S.modo)); }
  modos.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) conGloboQuieto(() => setModo(b.dataset.m)); });

  /* ---------- panel ---------- */
  // Selector de año: "Todos" y un botón por año (no aparece si solo hay uno). El elegido queda marcado.
  function chipsAnio(anios) {
    if (anios.length < 2) return '';
    const chip = (a, txt) => '<button type="button" data-act="anio" data-anio="' + (a || '') + '" aria-pressed="' + (S.anio === a) + '"' + (S.anio === a ? ' class="on"' : '') + '>' + txt + '</button>';
    return '<div class="anios" role="group" aria-label="Ver fotos por año"><i class="fa-regular fa-calendar" aria-hidden="true"></i>' + chip(null, 'Todos') + anios.map((a) => chip(a, a)).join('') + '</div>';
  }
  function rowTrip(v) {
    const n = S.anio ? D.paradasDe(v.id, S.anio).length : v.paradas.length;
    return '<button class="row" data-act="viaje" data-id="' + v.id + '" data-hl="trip:' + v.id + '"><img loading="lazy" decoding="async" src="' + v.portada + '" alt=""><span><span class="t">' + esc(v.nombre) + '</span><span class="s">' + (S.anio || v.aniosTexto) + ' · ' + n + plural(n, ' destino', ' destinos') + '</span></span><i class="fa-solid fa-chevron-right chev"></i></button>';
  }
  function panelMundo() {
    const r = D.resumen(S.anio), cifra = (n, uno, varios) => '<div><b>' + n + '</b>' + plural(n, uno, varios) + '</div>';
    return '<p class="eyebrow">Mi mundo</p><h2>Te recomiendo lugares <em>que ya viví</em></h2>' +
      '<p class="lead">Estos son lugares que recorrí en persona. Toca un viaje y mira mis fotos, mis tips y por qué te los recomiendo.</p>' +
      chipsAnio(D.anios) +
      '<div class="stats">' + cifra(r.destinos, 'destino', 'destinos') + cifra(r.paises, 'país', 'países') + cifra(r.fotos, 'foto', 'fotos') + '</div>' +
      '<div class="list">' + D.viajesDe(S.anio).map(rowTrip).join('') + '</div>';
  }
  function panelViaje() {
    const vj = D.viajes.find((v) => v.id === S.viaje), paises = [], n = paradas.length;
    paradas.forEach((id) => { const p = D.destinos[id].pais; if (paises.indexOf(p) < 0) paises.push(p); });
    const lead = S.anio && vj.anios.length > 1
      ? n + plural(n, ' parada', ' paradas') + ' con fotos de ' + S.anio + '. Elige una para verlas.'
      : n + ' paradas en ' + lista(paises) + '. Elige una para ver sus fotos.';
    return '<button class="back" data-act="mundo"><i class="fa-solid fa-arrow-left"></i> Todo mi mundo</button>' +
      '<p class="eyebrow">Viaje · ' + vj.aniosTexto + '</p><h2>' + esc(vj.nombre) + '</h2>' +
      '<p class="lead">' + lead + '</p>' + chipsAnio(vj.anios) +
      '<div class="list mt">' + paradas.map((id, i) => { const d = D.destinos[id], k = fotosDe(id, S.anio).length; return '<button class="row" data-act="dest" data-id="' + id + '" data-hl="dest:' + id + '"><span class="num">' + (i + 1) + '</span><img loading="lazy" decoding="async" src="' + cover(id, S.anio) + '" alt=""><span><span class="t">' + esc(d.nombre) + '</span><span class="s">' + esc(d.lugar) + ' · ' + k + plural(k, ' foto', ' fotos') + '</span></span><i class="fa-solid fa-chevron-right chev"></i></button>'; }).join('') + '</div>' +
      '<div class="acts mt"><a class="cta-wa" target="_blank" rel="noopener" href="' + wa('Hola Jenny, me encantó tu viaje por ' + vj.nombre + ' y quiero algo así. ¿Me ayudas a planearlo?') + '"><i class="fa-brands fa-whatsapp"></i> Quiero un viaje así</a></div>';
  }
  function panelDestino() {
    const id = S.dest, d = D.destinos[id], vj = tripOf(id), multi = vj.paradas.length > 1, fs = fotosDe(id, S.anio);
    // paradas visibles con el año elegido (p. ej. en 2026 Orlando tiene 2): numeración y anterior/siguiente
    const i = paradas.indexOf(id), prev = paradas[i - 1], next = paradas[i + 1], varias = paradas.length > 1;
    const deAnio = S.anio && d.anios.length > 1 ? ' de ' + S.anio : '';
    return '<button class="back" data-act="' + (multi ? 'volver-viaje' : 'mundo') + '"><i class="fa-solid fa-arrow-left"></i> ' + (multi ? esc(vj.nombre) + ' ' + vj.aniosTexto : 'Todo mi mundo') + '</button>' +
      '<p class="eyebrow"><img src="' + flag(d.pais) + '" alt=""> ' + esc(d.pais) + (varias ? ' · Parada ' + (i + 1) + ' de ' + paradas.length : '') + '</p>' +
      '<h2>' + esc(d.nombre) + '</h2><p class="lead">' + esc(d.lugar) + (d.anios.length > 1 ? '' : ' · ' + d.aniosTexto) + '</p>' + chipsAnio(d.anios) +
      '<div class="tip"><span class="firma">Tip de Jenny</span><p>' + esc(d.tip) + '</p></div>' +
      '<div class="acts"><a class="cta-wa" target="_blank" rel="noopener" href="' + wa('Hola Jenny, vi tus fotos de ' + d.nombre + ' y quiero ir. ¿Me ayudas a planearlo?') + '"><i class="fa-brands fa-whatsapp"></i> Quiero ir aquí</a>' +
      '<button class="ghost" data-act="fotos"><i class="fa-regular fa-images"></i> Ver ' + (fs.length === 1 ? 'la foto' : 'las ' + fs.length + ' fotos') + deAnio + '</button></div>' +
      (varias ? '<div class="prevnext">' + (prev ? '<button data-act="dest" data-id="' + prev + '">← ' + esc(D.destinos[prev].nombre) + '</button>' : '<span></span>') + (next ? '<button data-act="dest" data-id="' + next + '">' + esc(D.destinos[next].nombre) + ' →</button>' : '') + '</div>' : '');
  }
  function panelViajeros() {
    return '<p class="eyebrow">Mis viajeros</p><h2>Familias que ya <em>viajaron conmigo</em></h2>' +
      '<p class="lead">Ellos confiaron en mí para su viaje. Toca un lugar para leer su experiencia.</p>' +
      '<div class="list mt">' + D.lugaresViajeros.map((l) => { const rs = l.resenas.map(resena); return '<button class="row" data-act="lugar" data-id="' + l.id + '" data-hl="place:' + l.id + '"><span class="avs">' + rs.map((r) => '<img loading="lazy" decoding="async" src="' + r.micro + '" alt=""' + encuadre(r.encuadre) + '>').join('') + '</span><span><span class="t">' + esc(l.nombre) + '</span><span class="s">' + rs.map((r) => esc(r.nombre)).join(' · ') + '</span></span><i class="fa-solid fa-chevron-right chev"></i></button>'; }).join('') + '</div>' +
      '<p class="foot"><i class="fa-solid fa-heart" style="color:#EC6278"></i> ' + D.resenas.length + ' familias' + (D.resenas.every((r) => r.estrellas === 5) ? ' · 5 estrellas cada una' : '') + '</p>';
  }
  function panelLugar() {
    const l = D.lugaresViajeros.find((x) => x.id === S.lugar), rs = l.resenas.map(resena);
    return '<button class="back" data-act="mundo"><i class="fa-solid fa-arrow-left"></i> Todos mis viajeros</button>' +
      '<p class="eyebrow">Mis viajeros</p><h2>' + esc(l.nombre) + '</h2>' +
      rs.map((r) => '<article class="review" id="rv-' + r.id + '"><header><img loading="lazy" decoding="async" src="' + r.micro + '" alt=""' + encuadre(r.encuadre) + '><div><b>' + esc(r.nombre) + '</b><span>' + esc(r.destino.replace(/\n/g, ' · ')) + '</span><div class="stars">' + '<i class="fa-solid fa-star"></i>'.repeat(r.estrellas) + '</div></div></header><p class="rv-t">' + esc(r.texto.replace(/\\n/g, '\n').trim()) + '</p><button class="more" data-act="mas" data-id="' + r.id + '">Leer completa</button></article>').join('') +
      '<div class="acts mt"><a class="cta-wa" target="_blank" rel="noopener" href="' + wa('Hola Jenny, leí las experiencias de tus viajeros en ' + l.nombre + ' y quiero un viaje así.') + '"><i class="fa-brands fa-whatsapp"></i> Quiero un viaje así</a></div>';
  }
  /* ---------- barra fija (celular) ---------- */
  /**
   * Contenido de la barra fija del celular en un viaje, un destino o un lugar.
   * @typedef {Object} BarraNav
   * @property {{act: ('mundo'|'volver-viaje'), texto: string}} regreso  acción del botón de regreso y nombre del nivel de arriba
   * @property {string} titulo      nombre del viaje, destino o lugar abierto
   * @property {string} detalle     "8 paradas", "Parada 2 de 8", "2 familias"...
   * @property {boolean} pasos      destino con varias paradas visibles: lleva los botones ‹ ›
   * @property {?string} anterior   id de la parada anterior (null en la primera)
   * @property {?string} siguiente  id de la parada siguiente (null en la última)
   */
  /** @returns {?BarraNav} null en la vista general (ahí la barra lleva "Mis viajes / Mis viajeros") */
  function datosBarra() {
    if (S.nivel === 'viaje') {
      const vj = D.viajes.find((v) => v.id === S.viaje), n = paradas.length;
      return { regreso: { act: 'mundo', texto: 'Todo mi mundo' }, titulo: vj.nombre, detalle: n + plural(n, ' parada', ' paradas') + (S.anio && vj.anios.length > 1 ? ' · ' + S.anio : ''), pasos: false, anterior: null, siguiente: null };
    }
    if (S.nivel === 'destino') {
      // mismas reglas que el panel: regresa al viaje si tiene varias paradas; ‹ › recorren las paradas del año elegido
      const d = D.destinos[S.dest], vj = tripOf(S.dest), i = paradas.indexOf(S.dest), varias = paradas.length > 1;
      return {
        regreso: vj.paradas.length > 1 ? { act: 'volver-viaje', texto: vj.nombre } : { act: 'mundo', texto: 'Todo mi mundo' },
        titulo: d.nombre,
        detalle: varias ? 'Parada ' + (i + 1) + ' de ' + paradas.length : d.lugar,
        pasos: varias,
        anterior: varias && i > 0 ? paradas[i - 1] : null,
        siguiente: varias && i < paradas.length - 1 ? paradas[i + 1] : null
      };
    }
    if (S.nivel === 'lugar') {
      const l = D.lugaresViajeros.find((x) => x.id === S.lugar);
      return { regreso: { act: 'mundo', texto: 'Mis viajeros' }, titulo: l.nombre, detalle: quienesViajaron(l), pasos: false, anterior: null, siguiente: null };
    }
    return null;
  }
  /** @param {BarraNav} b */
  function barraHTML(b) {
    const paso = (id, clase, nombre, icono) => '<button type="button" class="bar-paso ' + clase + '"' +
      (id ? ' data-act="dest" data-id="' + id + '" aria-label="' + esc(nombre + ': ' + D.destinos[id].nombre) + '"' : ' disabled aria-label="' + nombre + '"') +
      '><i class="fa-solid ' + icono + '"></i></button>';
    return '<button type="button" class="bar-back" data-act="' + b.regreso.act + '" aria-label="Regresar a ' + esc(b.regreso.texto) + '"><i class="fa-solid fa-arrow-left"></i><span>' + esc(b.regreso.texto) + '</span></button>' +
      '<div class="bar-tit"><b>' + esc(b.titulo) + '</b><small>' + esc(b.detalle) + '</small></div>' +
      (b.pasos ? '<div class="bar-pasos">' + paso(b.anterior, 'prev', 'Parada anterior', 'fa-chevron-left') + paso(b.siguiente, 'next', 'Parada siguiente', 'fa-chevron-right') + '</div>' : '');
  }
  // En la vista general la barra muestra "Mis viajes / Mis viajeros"; en lo demás, el regreso, el título y ‹ ›.
  // Si el foco estaba en un botón de la barra (teclado o lector de pantalla), pasa al botón nuevo equivalente; si ese
  // quedó deshabilitado (última o primera parada) o ya no existe, a la otra flecha o al regreso; y al volver a la vista
  // general, al modo elegido. Así el foco nunca se pierde en la página.
  function renderBarra() {
    const b = datosBarra(), activo = document.activeElement;
    const foco = activo && barraNav.contains(activo) ? '.' + activo.className.trim().split(/\s+/).join('.') : '';
    barra.classList.toggle('sub', !!b);
    barraNav.innerHTML = b ? barraHTML(b) : '';
    if (!foco) return;
    const opciones = b ? [foco, '.bar-paso:not(:disabled)', '.bar-back'].map((s) => barraNav.querySelector(s)) : [modos.querySelector('button.on')];
    const nuevo = opciones.find((e) => e && !e.disabled);
    if (nuevo) nuevo.focus({ preventScroll: true });
  }

  /* ---------- pantalla quieta (celular) ---------- */
  // En el celular el panel va encima del globo: al cambiar de vista cambia de alto y empujaría el globo. Se queda
  // quieto lo que se está viendo: si es el globo (se tocó un pin, o el globo ocupa el 40 % o más de la pantalla bajo la
  // barra), la página se corrige al instante para que no se mueva; si es el texto, la página no se toca y el panel
  // cambia en su lugar. Nunca hay scroll animado ni se asoma la sección de arriba. Solo para toques dentro de
  // "Mi mundo": las llamadas desde otras secciones (verEnMapa) no la usan, para no cortar el scroll suave que las trae.
  function conGloboQuieto(accion, desdeGlobo) {
    if (!L.movil || !iniciado) { accion(); return; }
    const y0 = window.scrollY, g0 = stage.getBoundingClientRect(), sec0 = root.getBoundingClientRect().top, nav = navH();
    const arriba = nav + barra.offsetHeight, abajo = window.innerHeight;
    const seVe = Math.min(g0.bottom, abajo) - Math.max(g0.top, arriba);
    const anclar = desdeGlobo ? seVe >= 60 : seVe >= 0.4 * (abajo - arriba);
    accion();
    // se calcula con posiciones en la página: al cambiar el panel, Chrome pudo haber movido ya el scroll por su cuenta
    const y1 = window.scrollY, globo = stage.getBoundingClientRect().top + y1, seccion = root.getBoundingClientRect().top + y1;
    let y = anclar ? globo - g0.top : y0;
    y = Math.max(y, seccion - Math.max(sec0, nav)); // el inicio de la sección no baja de donde estaba ni del navbar
    if (Math.abs(y - y1) >= 1) window.scrollTo(0, y);
  }

  // filtro: solo cambió el año (mismo panel): sin animación de entrada ni scroll, y el foco sigue en el selector
  function renderPanel(filtro) {
    let h;
    if (S.modo === 'viajes') h = S.nivel === 'viaje' ? panelViaje() : S.nivel === 'destino' ? panelDestino() : panelMundo();
    else h = S.nivel === 'lugar' ? panelLugar() : panelViajeros();
    panelIn.innerHTML = h;
    renderBarra();
    actualizarGiro();
    // "Leer completa" solo en las reseñas que de verdad quedaron recortadas
    panelIn.querySelectorAll('.review').forEach((rv) => {
      const t = rv.querySelector('.rv-t'), mas = rv.querySelector('.more');
      if (t && mas && t.scrollHeight <= t.clientHeight + 1) mas.hidden = true;
    });
    if (filtro) {
      const b = panelIn.querySelector('.anios .on'); if (b) b.focus({ preventScroll: true });
      postHeight();
      return;
    }
    panelIn.classList.remove('entra'); void panelIn.offsetWidth; panelIn.classList.add('entra');
    // El panel no tiene scroll propio: si la página quedó a media sección, vuelve al inicio del panel nuevo
    // (solo tras una interacción; al montar, el scroll lo decide la navegación de la página).
    if (iniciado && !L.movil) {
      const dy = root.getBoundingClientRect().top - navH();
      if (dy < -2) window.scrollTo({ top: window.scrollY + dy, behavior: REDUCE ? 'auto' : 'smooth' });
    }
    postHeight();
  }
  // Acción de un botón con data-act del panel o de la barra fija del celular
  function ejecutar(b) {
    const act = b.dataset.act, id = b.dataset.id;
    if (act === 'viaje') selectViaje(id);
    else if (act === 'dest') selectDest(id);
    else if (act === 'mundo') backToMundo();
    else if (act === 'volver-viaje') backToViaje();
    else if (act === 'fotos') openLB(S.dest, 0);
    else if (act === 'anio') setAnio(b.dataset.anio ? +b.dataset.anio : null);
    else if (act === 'lugar') selectLugar(id);
    else if (act === 'mas') { const a = root.querySelector('#rv-' + id); a.classList.toggle('abierta'); b.textContent = a.classList.contains('abierta') ? 'Ver menos' : 'Leer completa'; postHeight(); }
  }
  // Las acciones que cambian de vista dejan el globo quieto en el celular; el año y "Leer completa" no mueven lo que
  // se tocó (cambia lo de abajo). Ninguna desplaza la página por su cuenta.
  const NAVEGAN = ['viaje', 'dest', 'mundo', 'volver-viaje', 'lugar'];
  function alTocar(e) {
    const b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
    if (NAVEGAN.indexOf(b.dataset.act) >= 0) conGloboQuieto(() => ejecutar(b));
    else ejecutar(b);
  }
  panel.addEventListener('click', alTocar);
  barra.addEventListener('click', alTocar);
  panel.addEventListener('mouseover', (e) => {
    const b = e.target.closest('[data-hl]'); root.querySelectorAll('.pin.hl').forEach((p) => p.classList.remove('hl'));
    if (!b) return; const [k, id] = b.dataset.hl.split(':'); const P = PINS[k === 'trip' ? 'trip' : k === 'dest' ? 'dest' : 'place'][id]; if (P) P.el.classList.add('hl');
  });
  panel.addEventListener('mouseleave', () => root.querySelectorAll('.pin.hl').forEach((p) => p.classList.remove('hl')));

  /* ---------- lightbox ---------- */
  // fotos: las del destino con el año elegido, agrupadas por año; el encabezado muestra el año de cada foto
  const LB = { dest: null, fotos: [], i: 0, open: false };
  const lbImg = lb.querySelector('.lb-img'), lbThumbs = lb.querySelector('.lb-thumbs');
  function openLB(dest, i) {
    const fs = fotosDe(dest, S.anio), d = D.destinos[dest], variosAnios = fs[0].anio !== fs[fs.length - 1].anio;
    LB.dest = dest; LB.fotos = fs; LB.i = i; LB.open = true;
    lb.querySelector('.lb-title').innerHTML = esc(d.nombre) + '<small></small>';
    const a = lb.querySelector('.lb-top .cta-wa'); a.href = wa('Hola Jenny, vi tus fotos de ' + d.nombre + ' y quiero ir. ¿Me ayudas a planearlo?'); a.querySelector('span').textContent = 'Quiero ir a ' + d.nombre;
    // con fotos de varios años, cada grupo de miniaturas empieza con su año
    lbThumbs.innerHTML = fs.map((f, j) => (variosAnios && (j === 0 || fs[j - 1].anio !== f.anio) ? '<span class="lb-anio">' + f.anio + '</span>' : '') + '<button data-j="' + j + '" aria-label="Foto ' + (j + 1) + ' · ' + f.anio + '"><img loading="lazy" decoding="async" src="' + f.micro + '" alt=""></button>').join('');
    showLB(); lb.classList.add('on'); lb.setAttribute('aria-hidden', 'false'); fijarPagina(true);
  }
  function showLB() {
    const d = D.destinos[LB.dest], fs = LB.fotos, f = fs[LB.i], thumbs = lbThumbs.querySelectorAll('button');
    lbImg.src = f.mini; const im = new Image(); im.onload = () => { if (LB.fotos[LB.i] === f) lbImg.src = f.grande; }; im.src = f.grande;
    lb.querySelector('.lb-title small').textContent = d.lugar + ' · ' + f.anio;
    lb.querySelector('.lb-txt').innerHTML = '<b>' + esc(f.titulo) + '</b>' + (f.descripcion ? ' · ' + esc(fix(f.descripcion)) : '');
    lb.querySelector('.lb-n').textContent = (LB.i + 1) + ' / ' + fs.length;
    thumbs.forEach((b, j) => b.classList.toggle('on', j === LB.i));
    const on = thumbs[LB.i]; if (on) lbThumbs.scrollTo({ left: on.offsetLeft - lbThumbs.clientWidth / 2 + 31, behavior: 'smooth' });
  }
  function stepLB(d) { const n = LB.fotos.length; LB.i = (LB.i + d + n) % n; showLB(); }
  function closeLB() { LB.open = false; lb.classList.remove('on'); lb.setAttribute('aria-hidden', 'true'); fijarPagina(false); reanudar(); }
  // Con el lightbox abierto la rueda o el dedo no recorren la página de atrás (al cerrar, "Mi mundo" sigue en su lugar).
  // El ancho de la barra de scroll se compensa para que el contenido no brinque.
  function fijarPagina(si) {
    const html = document.documentElement;
    if (si === (html.style.overflow === 'hidden')) return;
    html.style.paddingRight = si ? (window.innerWidth - html.clientWidth) + 'px' : '';
    html.style.overflow = si ? 'hidden' : '';
  }
  lb.querySelector('.lb-x').addEventListener('click', closeLB);
  lb.querySelector('.prev').addEventListener('click', () => stepLB(-1));
  lb.querySelector('.next').addEventListener('click', () => stepLB(1));
  lbThumbs.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) { LB.i = +b.dataset.j; showLB(); } });
  // Deslizar la foto a los lados (dedo o mouse) cambia de foto: la foto sigue al dedo y, al soltar, pasa a la
  // siguiente o a la anterior si se movió más de 50 px; si no, regresa a su lugar. Con zoom de dos dedos no se
  // desliza: el dedo mueve la vista ampliada.
  const lbMain = lb.querySelector('.lb-main');
  const conZoom = () => !!window.visualViewport && window.visualViewport.scale > 1.01;
  let desliz = null, finDesliz = -1e9;
  lbMain.addEventListener('click', (e) => { if (e.target === e.currentTarget && performance.now() - finDesliz > 400) closeLB(); });
  lbMain.addEventListener('pointerdown', (e) => {
    if (e.button > 0 || (desliz && !e.isPrimary) || e.target.closest('.lb-nav') || conZoom()) return;
    desliz = { x: e.clientX, id: e.pointerId, dx: 0 }; finDesliz = -1e9;
    lbImg.style.transition = 'none';
  });
  lbMain.addEventListener('pointermove', (e) => {
    if (!desliz || e.pointerId !== desliz.id) return;
    desliz.dx = e.clientX - desliz.x;
    lbImg.style.transform = 'translateX(' + desliz.dx + 'px)';
  });
  const soltarFoto = (e) => {
    if (!desliz || e.pointerId !== desliz.id) return;
    const dx = desliz.dx, paso = dx > 50 ? -1 : dx < -50 ? 1 : 0;
    desliz = null;
    if (Math.abs(dx) > 8) finDesliz = performance.now(); // fue un deslizamiento: el clic de al soltar no cierra el visor
    lbImg.style.transition = paso ? 'none' : '';
    lbImg.style.transform = '';
    if (paso) { stepLB(paso); requestAnimationFrame(() => { lbImg.style.transition = ''; }); }
  };
  on(window, 'pointerup', soltarFoto); on(window, 'pointercancel', soltarFoto);
  lb.addEventListener('dragstart', (e) => e.preventDefault());
  // con zoom de dos dedos, el navegador vuelve a mover la vista ampliada en cualquier dirección (CSS .lb-zoom)
  if (window.visualViewport) on(window.visualViewport, 'resize', () => lb.classList.toggle('lb-zoom', conZoom()));
  on(window, 'keydown', (e) => {
    if (LB.open) { if (e.key === 'ArrowRight') stepLB(1); else if (e.key === 'ArrowLeft') stepLB(-1); else if (e.key === 'Escape') closeLB(); return; }
    if (e.key === 'Escape') { if (S.nivel === 'destino') backToViaje(); else if (S.nivel !== 'mundo') backToMundo(); }
  });

  /* ---------- arrastre ---------- */
  // El giro (donde giroPermitido) puede empezar en cualquier parte del escenario, también sobre un pin o su etiqueta:
  // mientras el mouse se mueve menos de UMBRAL px es un toque (el pin recibe su clic); después es un giro y el clic
  // que llega al soltar se descarta. Solo cuenta el primer dedo.
  // Con el dedo el giro solo arranca con un trazo claramente de lado (UMBRAL_LADO px y 1.3 veces más horizontal que
  // vertical); si el trazo va hacia arriba o abajo se suelta y el navegador recorre la página (touch-action: pan-y).
  const UMBRAL = 6, UMBRAL_LADO = 10;
  let toque = null, finGiro = -1e9;
  stage.addEventListener('pointerdown', (e) => {
    if (e.button > 0 || (toque && !e.isPrimary) || e.target.closest('#modos') || !giroPermitido()) return;
    if (drag) { drag = null; stage.classList.remove('arrastrando'); } // un giro anterior que no llegó a cerrarse
    toque = { x: e.clientX, y: e.clientY, id: e.pointerId }; finGiro = -1e9; // un toque nuevo sí puede abrir un pin
    vel = { lon: 0, lat: 0 }; lastInteract = performance.now(); hideHint();
  });
  // las fotos de los pines no se arrastran como imagen (el navegador cancelaría el giro)
  stage.addEventListener('dragstart', (e) => e.preventDefault());
  stage.addEventListener('pointermove', (e) => {
    if (!toque || e.pointerId !== toque.id) return;
    if (!drag) {
      const dx = Math.abs(e.clientX - toque.x), dy = Math.abs(e.clientY - toque.y);
      if (e.pointerType === 'touch') {
        if (dy >= UMBRAL && dy >= dx) { toque = null; return; } // hacia arriba o abajo: es scroll de la página
        if (dx < UMBRAL_LADO || dx <= 1.3 * dy) return;
      } else if (Math.hypot(dx, dy) < UMBRAL) return;
      drag = { x: toque.x, y: toque.y, lon: V.lon, lat: V.lat, t: performance.now(), lx: toque.x, ly: toque.y };
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      stage.classList.add('arrastrando'); tween = null;
    }
    const k = 180 / Math.PI / (L.R0 * V.z), now = performance.now(), dt = Math.max(8, now - drag.t) / 1000;
    V.lon = drag.lon - (e.clientX - drag.x) * k;
    V.lat = clamp(drag.lat + (e.clientY - drag.y) * k, -72, 72);
    vel.lon = -(e.clientX - drag.lx) * k / dt; vel.lat = (e.clientY - drag.ly) * k / dt;
    drag.t = now; drag.lx = e.clientX; drag.ly = e.clientY; dirty = true; lastInteract = now;
  });
  // en window: el pin o la polaroid donde empezó el toque pueden desaparecer antes de soltar
  const endDrag = (e) => {
    if (!toque || e.pointerId !== toque.id) return;
    toque = null;
    if (!drag) return;
    drag = null; stage.classList.remove('arrastrando'); lastInteract = finGiro = performance.now();
    vel.lon = clamp(vel.lon, -160, 160); vel.lat = clamp(vel.lat, -100, 100);
  };
  on(window, 'pointerup', endDrag); on(window, 'pointercancel', endDrag);
  // el clic que el navegador manda justo al soltar un giro no abre el pin ni la polaroid donde empezó
  stage.addEventListener('click', (e) => { if (performance.now() - finGiro < 400) { e.stopPropagation(); e.preventDefault(); } }, true);

  /* ---------- estilo y mensajes ---------- */
  function setEstilo(e) {
    S.estilo = e === 'ilustrado' ? 'ilustrado' : 'realista';
    app.dataset.estilo = S.estilo; root.dataset.estilo = S.estilo;
    if (S.estilo === 'ilustrado') { ensureIlluTex(); if (GLG) GLG.clear(); }
    drawStars(); drawIllu(); dirty = true;
  }

  /* ---------- bucle ---------- */
  // El globo solo se dibuja cuando está en pantalla y sin el lightbox encima: mientras se recorre el resto de la
  // página o se ven fotos, el teléfono no gasta en un globo que no se ve.
  let lastT = performance.now(), enPantalla = true, pausaDesde = 0;
  const pausado = () => !enPantalla || LB.open;
  // Celular: al volver a dibujar, un vuelo de cámara que quedó a medias sigue donde iba y uno pedido mientras el globo
  // no se veía empieza ahora: el vuelo se ve completo y las polaroids salen cuando de verdad llega.
  function reanudar() {
    if (raf || dead || pausado()) return;
    const ahora = performance.now();
    if (L.movil && tween && pausaDesde) tween.t0 = ahora - clamp(pausaDesde - tween.t0, 0, tween.dur);
    pausaDesde = 0; lastT = ahora; dirty = true; raf = requestAnimationFrame(frame);
  }
  function frame(now) {
    raf = 0;
    if (dead) return;
    if (pausado()) { pausaDesde = performance.now(); return; }
    const dt = clamp((now - lastT) / 1000, 0, 0.05); lastT = now;
    stepTween(now);
    if (!tween && !drag) {
      if (Math.abs(vel.lon) > 0.02 || Math.abs(vel.lat) > 0.02) {
        V.lon += vel.lon * dt; V.lat = clamp(V.lat + vel.lat * dt, -72, 72);
        const f = Math.exp(-dt * 3.2); vel.lon *= f; vel.lat *= f; dirty = true;
      } else if (S.nivel === 'mundo' && !REDUCE && now - lastInteract > 2600 && !S.hover) { V.lon -= dt * 4.5; dirty = true; }
    }
    V.lon = ((V.lon + 540) % 360) - 180;
    V.R = L.R0 * V.z;
    if (dirty) { if (S.estilo === 'realista') { if (GLG) GLG.draw(); } else drawIllu(); dirty = false; }
    updatePins(dt);
    drawFx(now / 1000);
    raf = requestAnimationFrame(frame);
  }
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => { enPantalla = es[es.length - 1].isIntersecting; reanudar(); }, { rootMargin: '120px 0px' });
    io.observe(stage);
    offs.push(() => io.disconnect());
  }

  let lastW = 0, lastH = 0, iniciado = false;
  const medir = () => { lastW = root.clientWidth; lastH = L.movil ? 0 : stage.clientHeight; };
  // en escritorio el alto del globo depende del alto de la ventana; en móvil solo el ancho (la barra del navegador cambia el alto)
  on(window, 'resize', () => { if (root.clientWidth !== lastW || (!L.movil && stage.clientHeight !== lastH)) { layout(); medir(); } });
  layout();
  // en el celular la vista general arranca con América al centro: los 5 viajes se ven con su nombre
  if (L.movil) V.lon = -62;
  setEstilo(S.estilo);
  renderPanel();
  medir();
  iniciado = true;
  raf = requestAnimationFrame(frame);
  if (qs.get('viaje')) setTimeout(() => selectViaje(qs.get('viaje')), 400);
  if (qs.get('destino')) setTimeout(() => selectDest(qs.get('destino')), 400);
  if (qs.get('lugar')) setTimeout(() => { setModo('viajeros'); selectLugar(qs.get('lugar')); }, 400);

  return {
    setEstilo,
    verViaje: (id) => selectViaje(id),
    verDestino: (id) => selectDest(id),
    focoLugar: (lugar) => { if (S.modo !== 'viajeros') setModo('viajeros'); setTimeout(() => selectLugar(lugar), 60); },
    verLugarEnGlobo,
    destroy() { dead = true; cancelAnimationFrame(raf); offs.forEach((f) => f()); if (LB.open) fijarPagina(false); root.innerHTML = ''; root.classList.remove('mm', 'movil'); }
  };
}
